module.exports = __webpack_public_path__ + "static/media/mobileWinnerBage.svg";